import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Footer from 'components/Footer';
import ZfreedomLogo from 'assets/images/ZFLogo.png';

type LoginLayoutProps = {
    bottomLinks?: React.ReactNode;
    children?: React.ReactNode;
};

const LoginLayout = ({ bottomLinks, children }: LoginLayoutProps) => {
    return (
        <>
            <div className="login-page pt-2 pt-sm-5 pb-xl-4 pb-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5} xxl={4} className="login-column">
                            <div className='logo-container'>
                                <img src={ZfreedomLogo} alt="ZFreedom Logo" />
                            </div>
                            {children}
                        </Col>
                        {bottomLinks}
                    </Row>
                </Container>    
            </div>
            <Footer />
        </>
    );
};

export default LoginLayout;
